import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";

// import {
//     GET_RP_DETAIL_GAS_DELIVERY_FUEL,
//     baseUrl,
// } from "../../../helpers/url_api_constant";

import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
// import OveruseByContact from "./OveruseByContact";
import PropTypes from "prop-types";
import Select from "react-select";
import TabSummary from "./TabSummary";
import TabBillingSummary from "./TabBillingSummary";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import classnames from "classnames";
//i18n
import { withTranslation } from "react-i18next";

function DetailDeliveryGasFuelGas(props) {
    let history = useHistory();
    let { pid, date } = useParams();
    const dispatch = useDispatch();
    const permission = getPermission();
    const [activeTab, setActiveTab] = useState("1");

    //onInit//
    useEffect(function () {
        // fetchData();
    }, []);
    //onInit//

    const SelectStyle = {
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
            ...provided,
            ...isFocused && ({ backgroundColor: '#2E3460' })
        }),
    }

    const gotoMainMenu = () => {
        history.push({
            pathname: "/delivery-gas-fuel-gas-report", state: {  // location state
                goBack: true,
            },
        });
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                                        <h1 className="mb-sm-0 font-size-20">
                                            Delivery Gas / Fuel Gas( Detail )
                                        </h1>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="#" style={{ color: "#556ee6" }}>
                                                        Report
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to="/delivery-gas-fuel-gas-report" style={{ color: "#556ee6" }}>
                                                        Delivery Gas / Fuel Gas
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    Delivery Gas / Fuel Gas ( Detail )
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                    <hr />

                                    {/* <Row>
                                        <Col
                                            sm="12"
                                            className="d-flex align-items-center justify-content-end"
                                        >
                                            <div className="d-grid gap-2 d-md-block">
                                                <Button
                                                    onClick={() => gotoMainMenu()}
                                                    // className="btn-rounded"
                                                    color="secondary"
                                                    className="mt-2 mb-2"
                                                >
                                                    <i className="fas fa-angle-double-left"></i>
                                                    &nbsp; Back
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row> */}

                                    <Row className="mt-0">
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: activeTab === "1",
                                                    })}
                                                    onClick={() => {
                                                        setActiveTab("1");
                                                        // dataConfirmModal(true);
                                                    }}
                                                >
                                                    Summary
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: activeTab === "2",
                                                    })}
                                                    onClick={() => {
                                                        setActiveTab("2");
                                                        // dataConfirmModal(true);
                                                    }}
                                                >
                                                    Summary Billing
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </Row>

                                    <Row>
                                        <TabContent
                                            activeTab={activeTab}
                                            className="p-3 text-muted"
                                        >
                                            <TabPane tabId="1">
                                                <TabSummary deliveryGasYear={date} />
                                            </TabPane>

                                            <TabPane tabId="2">
                                                <TabBillingSummary deliveryGasYear={date} />
                                            </TabPane>
                                        </TabContent>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    );
}

DetailDeliveryGasFuelGas.propTypes = {
    t: PropTypes.any,
};


export default DetailDeliveryGasFuelGas;
